module.exports = __webpack_public_path__ + "static/img/ACV Auctions.38e2ad2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/ACV Auctions.jpg
// module id = 6VLk
// module chunks = 1